




















import Vue from "vue";

export default Vue.extend({
  name: "SubscriptionTypeBtns",
  watch: {
    input(val) {
      this.$emit("changeTime", val ? "YEAR" : "MONTH");
    },
  },
  data: () => ({
    input: null,
  }),
});
